import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "square",
  "use": "square-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"square\">\n  <path d=\"M448,0 L64,0 C28.8,0 0,28.8 0,64 L0,448 C0,483.2 28.8,512 64,512 L448,512 C483.2,512 512,483.2 512,448 L512,64 C512,28.8 483.2,0 448,0 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol